module.exports = ".alert {\n  padding: 10px;\n  margin-bottom: 2vh;\n  width: 100%;\n  border: 1px solid red;\n  border-radius: 0;\n}\n.alert p {\n  color: red;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/_log-in/log-in.component.scss
// module id = ./src/app/user/_log-in/log-in.component.scss
// module chunks = main